import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { QUERY_KEY } from '../utils/constants'
import {
    fetchFirebaseToken,
    fetchNotificationData,
    deleteNotificationById
} from '../api/notificationApi'

export const useFirebaseToken = () => {
    return useMutation({
        mutationKey: [QUERY_KEY.GET_FIREBASE_TOKEN],
        mutationFn: async ({
            device_name,
            device_id,
            device_type,
            push_token
        }) => {
            const resp = await fetchFirebaseToken(
                device_name,
                device_id,
                device_type,
                push_token
            )
            return resp
        }
    })
}

export const useNotificationData = (uuid, filters, options = {}) => {
    return useQuery({
        queryKey: [QUERY_KEY.GET_NOTIFICATIONS, uuid, filters],
        queryFn: () => {
            return fetchNotificationData(uuid, filters)
        },
        enabled: !!uuid,
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        ...options
    })
}

export const useDeleteNotification = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (id) => {
            const resp = await deleteNotificationById(id)
            return resp
        },
        onSuccess: () => {
            queryClient.invalidateQueries([QUERY_KEY.GET_NOTIFICATIONS])
        }
    })
}
